import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Close } from '@mui/icons-material';
import { Box, Dialog, DialogContent, DialogTitle, Button, DialogActions, Table, TableHead, TableRow, TableCell, TableBody, Typography, IconButton, Divider } from '@mui/material';
import ProjectDetailsPartialCreate from './ProjectDetailsPartialCreate';
import ProjectDetailsPartialItem from '../../../../components/items/ProjectDetailsPartialItem';

const styles = {
  container: {
    display: 'block',
  },
  content: {
    paddingY: 0,
  },
  actions: {
    paddingRight: '1rem'
  },
  title: {
    my: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  fieldWrapper: {
    px: '1rem'
  }
}

const ProjectDetailsPartials = props => {
  const partials = useSelector(state => state.partials.list);
  const [openCreate, setOpenCreate] = useState(false);

  const handleClose = e => {
    e?.preventDefault();
    props.onClose();
  }

  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  return (
    <>
      <Dialog
        open={props.open}
        onClose={handleClose}
      >
        <DialogTitle>
        <Box sx={styles.title}>
            <Typography variant="h5">Aportaciones</Typography>
            <IconButton onClick={handleClose}><Close /></IconButton>
          </Box>
          <Divider />
        </DialogTitle>
        <DialogContent sx={styles.content}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Concepto</TableCell>
                <TableCell>Totales</TableCell>
                <TableCell>Pagadas</TableCell>
                <TableCell>Por pagar</TableCell>
                <TableCell>Guardar</TableCell>
                <TableCell>Borrar</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {partials.map(partial => <ProjectDetailsPartialItem key={partial._id} {...partial} />)}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions sx={styles.actions}>
          <Button onClick={handleOpenCreate}>Añadir</Button>
        </DialogActions>
      </Dialog>
      <ProjectDetailsPartialCreate open={openCreate} onClose={handleCloseCreate} />
    </>
  );
}

export default ProjectDetailsPartials;
